import { getErrorMessage } from "@/helpers/handleErrorResponse";
import { GetLanguageResponse } from "@/types/language";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const getLanguages = async (): Promise<GetLanguageResponse[]> => {
  try {
    const { data } = await axiosInstance.get(`/v1/languages`);
    return data as GetLanguageResponse[];
  } catch (error) {
    const { status, message } = getErrorMessage(error);

    const newError = new CustomError(message, status);
    throw newError;
  }
};
